import firebase from 'firebase/app';
import 'firebase/auth';
import Vue from 'vue';
import Router from 'vue-router';
import TsumConfig from '@/components/config.TsumTsum.vue';
import CookieConfig from '@/components/config.CookieKingdom.vue';
import MLB9InningsConfig from '@/components/config.MLB9Innings.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'intro' },
      // TODO: enable this when you want A/B tests
      // beforeEnter(to, from, next) {
      //   if (Math.random() < 0.5) {
      //     next("/intro");
      //   } else {
      //     next("/welcome");
      //   }
      // },
    },
    {
      path: '/intro',
      name: 'intro',
      // component: Intro,
      component: () => import(/* webpackChunkName: "intro" */ '@/views/Intro.vue'),
    },
    {
      path: '/welcome',
      name: 'welcome',
      // component: Welcome,
      component: () => import(/* webpackChunkName: "welcome" */ '@/views/Welcome.vue'),
    },
    {
      path: '/login',
      name: 'login',
      // component: Login,
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      beforeEnter: (to, from, next) => {
        const currentUser = firebase.auth().currentUser;
        if (currentUser) {
          next('/home');
        } else {
          next();
        }
      },
    },
    {
      path: '/home',
      name: 'home',
      // component: Home,
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/tsumConfig',
      name: 'tsumConfig',
      component: TsumConfig,
      // component: () => import(/* webpackChunkName: "tsumConfig" */ '@/components/config.TsumTsum.vue'),
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: '/cookieConfig',
      name: 'cookieConfig',
      component: CookieConfig,
      // component: () => import(/* webpackChunkName: "cookieConfig" */ '@/components/config.CookieKingdom.vue'),
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: '/mlb9iConfig',
      name: 'mlb9iConfig',
      component: MLB9InningsConfig,
      // component: () => import(/* webpackChunkName: "mlb9iConfig" */ '@/components/config.MLB9Innings.vue'),
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: '/plan/:supportGame?',
      name: 'plan',
      // component: Plan,
      component: () => import(/* webpackChunkName: "plan" */ '@/views/Plan.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/purchase',
      name: 'purchase',
      // component: Purchase,
      component: () => import(/* webpackChunkName: "purchase" */ '@/views/Purchase.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/ecpay',
      name: 'ecpay',
      // component: ECPay,
      component: () => import(/* webpackChunkName: "ecpay" */ '@/views/ECPay.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/paypal',
      name: 'paypal',
      // component: PayPal,
      component: () => import(/* webpackChunkName: "paypal" */ '@/views/PayPal.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/stripe',
      name: 'stripe',
      // component: Stripe,
      component: () => import(/* webpackChunkName: "stripe" */ '@/views/Stripe.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/trial/:supportGame?',
      name: 'trial',
      component: () => import(/* webpackChunkName: "trial" */ '@/views/Trial.vue'),
      meta: {
        requiresAuthToLogin: true,
      },
      props: true,
    },
    {
      path: '/tsum-record/:recordId?',
      name: 'tsum-record',
      component: () => import(/* webpackChunkName: "TsumDashboard" */ '@/views/TsumDashboard.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/faq',
      redirect: '/support',
    },
    {
      path: '/support',
      name: 'support',
      component: () => import(/* webpackChunkName: "Support" */ '@/views/Support.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/coupon/:supportGame?',
      name: 'coupon',
      component: () => import(/* webpackChunkName: "coupon" */ '@/views/Coupon.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "PrivacyPolicy" */ '@/views/PrivacyPolicy.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () => import(/* webpackChunkName: "TermsOfService" */ '@/views/TermsOfService.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/xrpc-login',
      name: 'xrpc-login',
      component: () => import(/* webpackChunkName: "PCLogin" */ '@/views/PCLogin.vue'),
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAuthToLogin = to.matched.some(record => record.meta.requiresAuthToLogin);

  if (requiresAuth && !currentUser) next('/intro');
  else if (requiresAuthToLogin && !currentUser) next('/login');
  else next();
});

export default router;
